import axios from "axios";
import {addAuthInterceptor, createApiClient} from "./authInterceptor";


// Base URL (can be moved to a config file if needed)
// http://4.188.94.25/ 
const baseURL = process.env.REACT_APP_SVT_ADMIN_CORE_API_BASE_URL;

// Create the API clients with the appropriate headers
const apiGetClient = createApiClient(baseURL, "application/json");
const apiPostClient = createApiClient(baseURL, "application/json");
const apiPutClient = createApiClient(baseURL, "application/json");
const apiPostImageClient = createApiClient(baseURL, "multipart/form-data");
const apiPutImageClient = createApiClient(baseURL, "multipart/form-data");
const apiUserAppClient = createApiClient(baseURL, "application/json");
const apiUserFormClient = createApiClient(baseURL, "multipart/form-data");

// Apply interceptor to each client
[apiGetClient, apiPostClient, apiPutClient, apiPostImageClient, apiPutImageClient, apiUserAppClient, apiUserFormClient]
    .forEach(addAuthInterceptor);

export {
    apiGetClient,
    apiPostClient,
    apiPutClient,
    apiPostImageClient,
    apiPutImageClient,
    apiUserAppClient,
    apiUserFormClient,
};